import { render, staticRenderFns } from "./suggestionSource.vue.html?vue&type=template&id=3a70a702&"
import script from "./suggestionSource.ts?vue&type=script&lang=ts&"
export * from "./suggestionSource.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports